var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 471",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "jcb_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007B40",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B330",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "jcb_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2970",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DBA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "jcb_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B2F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30138",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0E4C96",
    width: 750,
    height: 471,
    rx: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 347c0 41-33 75-75 75H133V124c0-41 33-75 75-75h409v298z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 242h35c12 3 15 20 4 26-7 4-16 2-23 2h-16v-28zm42-32c2 9-7 17-15 16h-27v-26h32c5 1 9 5 10 10zm64-136v272c0 27-24 50-51 51h-81V287h88c14-1 29-10 29-25 2-15-12-25-26-27-5 0-5-2 0-2 13-3 23-16 19-30-3-14-18-19-31-19h-79v-62c2-26 27-48 53-48h79z",
    fill: "url(#jcb_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 125c0-27 25-51 52-51h80v273c-1 26-25 49-51 50h-81V284c26 6 53 8 80 4 16-2 34-10 39-27 4-14 2-29 2-43v-34h-46v67c-2 14-15 22-28 22-16 0-48-12-48-12l1-136z",
    fill: "url(#jcb_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 197c-3 1-1-8-1-11v-64c2-27 27-49 54-48h78v273c-1 26-25 49-51 50h-81V273c18 15 43 17 66 17 17 0 35-2 51-6v-23c-19 9-41 15-62 10-14-4-25-18-25-33-2-16 8-32 23-37 19-6 40-2 58 6 4 2 8 5 6-2v-18c-30-7-62-9-92-2-9 3-17 7-24 12z",
    fill: "url(#jcb_svg__c)"
  }))));
}

export default SvgJcb;